import { syncLoTokenToStrataCookies, expireAuthAndRedirectToLogin } from "../syncStrataSession.js";

const CUSTOMER_DISABLED_CODE = 1503;

export const ORG_SWITCH_NOTICE_KEY = "orgSwitchNotice";

const PRESERVE_LOCAL_PATTERNS = [
  "statsig.stable_id.",
  "statsig.session_id.",
  "statsig.last_modified_time.",
  "_grecaptcha",
  "_gcl_ls",
];

/**
 * Switch the signed-in session to another organization and reload.
 * Mirrors HomePage.handleBranchSwitch so Bluerate "Edit it in …" lands on
 * the same auth/session cleanup path as the sidebar switcher.
 */
export async function switchOrganization(targetCustomerId, options = {}) {
  const token = sessionStorage.getItem("ZeitroA");
  if (!token) {
    throw new Error("Please sign in again.");
  }

  const res = await fetch("/api/v1/los/auth/switch-branch", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ targetCustomerId }),
  });
  if (res.status === 401) {
    expireAuthAndRedirectToLogin();
    throw new Error("Please sign in again.");
  }
  const data = await res.json();
  if (data.code === CUSTOMER_DISABLED_CODE) {
    throw new Error("This organization is disabled.");
  }
  if (data.code !== 0 || !data.data) {
    throw new Error(data.errMessage || "Failed to switch organization");
  }

  const newToken = data.data.token;
  const customerId = data.data.customerId;

  sessionStorage.setItem("ZeitroA", newToken);
  syncLoTokenToStrataCookies(newToken);

  Object.keys(sessionStorage).forEach((key) => {
    if (key !== "ZeitroA") {
      sessionStorage.removeItem(key);
    }
  });

  Object.keys(localStorage).forEach((key) => {
    if (!PRESERVE_LOCAL_PATTERNS.some((pattern) => key.startsWith(pattern))) {
      localStorage.removeItem(key);
    }
  });

  localStorage.setItem("customerid", customerId);

  if (options.notice) {
    sessionStorage.setItem(ORG_SWITCH_NOTICE_KEY, options.notice);
  }

  window.location.href = options.redirectTo || "/app/welcome";
  return data.data;
}
